import { render } from "./SmsDashboard.vue?vue&type=template&id=3b78b474&scoped=true"
import script from "./SmsDashboard.vue?vue&type=script&lang=js"
export * from "./SmsDashboard.vue?vue&type=script&lang=js"

import "./SmsDashboard.vue?vue&type=style&index=0&id=3b78b474&scoped=true&lang=css"

import exportComponent from "/Users/abayomi/IdeaProjects/microservice-2/harvest-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b78b474"]])

export default __exports__